import { EventExportStatus } from '../../../generated/api.graphql';

export const GuestListImportStatus = Object.freeze({
  PENDING: EventExportStatus.Pending,
  READY: EventExportStatus.Ready,
  FAILED: EventExportStatus.Failed,
});
export type GuestListImportStatus = (typeof GuestListImportStatus)[keyof typeof GuestListImportStatus];
